// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoBlue from '../assets/logo_blue.png';
import { trackNavClick } from '../analytics/events';
import { clearStoredConsent } from '../analytics/consent';

export default function Footer() {
  const { t } = useTranslation();

  const onNav = (target) => () => trackNavClick({ target, location: 'footer' });

  const onManageCookies = (e) => {
    e.preventDefault();
    trackNavClick({ target: 'manage_cookies', location: 'footer' });
    clearStoredConsent();
    window.location.reload();
  };

  return (
    <footer className="App-footer">
      <img src={logoBlue} alt="Logo Monite" className="monite-logo-footer" width="120" height="40" loading="lazy" />
      <div className="footer-links">
        <Link to="/#features" onClick={onNav('features')}>{t('common:features')}</Link>
        <Link to="/#about" onClick={onNav('about')}>{t('common:nav_about')}</Link>
        <Link to="/faq" onClick={onNav('faq')}>{t('common:nav_faq')}</Link>
        <Link to="/chypre" onClick={onNav('chypre')}>Monite à Chypre</Link>
        <Link to="/conditions-generales-dutilisation" onClick={onNav('cgu')}>CGU</Link>
        <Link to="/conditions-generales-de-vente-internet" onClick={onNav('cgv')}>CGV</Link>
        <Link to="/politique-de-confidentialite" onClick={onNav('privacy')}>Politique de Confidentialité</Link>
        <Link to="/#testimonials" onClick={onNav('testimonials')}>{t('common:testimonials_title')}</Link>
        <Link to="/#contact" onClick={onNav('contact')}>{t('common:contact')}</Link>
        <a href="#manage-cookies" onClick={onManageCookies}>{t('common:consent_banner.manage')}</a>
      </div>
      <p>&copy; {new Date().getFullYear()} Monite. {t('common:footer_rights')}</p>
    </footer>
  );
}
